export const ROLES_ID = {
  //** System Rols */
  SU_ADMIN: 1000,
  ADMIN: 1001,
  SUB_ADMIN: 1002,
  INFRASTRUCTURE_SCANNER: 10010,
  SERVICE_TECHNICIAN: 10011,
  SALES_REPRESENTATIVE: 10012,
  TECHNICIAN: 10013,
  INVENTORY: 10014,

  MANAGER: 4000,
  DEPARTMENT_MANAGER: 4001,
  EMPLOYEE: 4002,
};

export const ROLES = [
  { id: ROLES_ID.MANAGER, name: "MANAGER" },
  { id: ROLES_ID.EMPLOYEE, name: "EMPLOYEE" },
  { id: ROLES_ID.DEPARTMENT_MANAGER, name: "DEPARTMENT_MANAGER" },
];

export const SYSTEM_ROLES = [
  { id: ROLES_ID.ADMIN, name: "ADMIN" },
  { id: ROLES_ID.SUB_ADMIN, name: "SUB_ADMIN" },
  { id: ROLES_ID.INFRASTRUCTURE_SCANNER, name: "INFRASTRUCTURE_SCANNER" },
  { id: ROLES_ID.SERVICE_TECHNICIAN, name: "SERVICE_TECHNICIAN" },
  { id: ROLES_ID.SALES_REPRESENTATIVE, name: "SALES_REPRESENTATIVE" },
  { id: ROLES_ID.TECHNICIAN, name: "TECHNICIAN" },
  { id: ROLES_ID.INVENTORY, name: "INVENTORY" },
];

export const ELECTRON_LAB_ONLY_ROLES = [
  ROLES_ID.INVENTORY,
  ROLES_ID.SERVICE_TECHNICIAN,
  ROLES_ID.SALES_REPRESENTATIVE,
];

//** System Rols */
export const SU_ADMIN = [ROLES_ID.SU_ADMIN];
export const ADMIN = [ROLES_ID.SU_ADMIN, ROLES_ID.ADMIN];
export const INFRASTRUCTURE_SCANNER = [ROLES_ID.SU_ADMIN, ROLES_ID.ADMIN, ROLES_ID.INFRASTRUCTURE_SCANNER]
export const SERVICE_TECHNICIAN = [ROLES_ID.SU_ADMIN, ROLES_ID.ADMIN, ROLES_ID.SERVICE_TECHNICIAN]
export const SALES_REPRESENTATIVE = [ROLES_ID.SU_ADMIN, ROLES_ID.ADMIN, ROLES_ID.SALES_REPRESENTATIVE]
export const TECHNICIAN = [ROLES_ID.SU_ADMIN, ROLES_ID.ADMIN, ROLES_ID.TECHNICIAN]
export const INVENTORY = [ROLES_ID.SU_ADMIN, ROLES_ID.ADMIN, ROLES_ID.INVENTORY]

export const MANAGER = [
  ROLES_ID.SU_ADMIN,
  ROLES_ID.ADMIN,
  ROLES_ID.MANAGER
];

export const DEPARTMENT_MANAGER = [
  ROLES_ID.SU_ADMIN,
  ROLES_ID.ADMIN,
  ROLES_ID.MANAGER,
  ROLES_ID.DEPARTMENT_MANAGER,
];

export const EMPLOYEES = [
  ROLES_ID.SU_ADMIN,
  ROLES_ID.ADMIN,
  ROLES_ID.MANAGER,
  ROLES_ID.DEPARTMENT_MANAGER,
  ROLES_ID.EMPLOYEE,
];
